<template>
	<b-modal ref="profile_modal"
			 size="lg"
			 bodyClass="p-0"
			 v-bind:no-close-on-backdrop=true
			 :hide-header=true
			 v-model="is_show_modal"
			 :dialogClass=dialog_class_draw>

		<template v-slot:modal-header="{ close }">
			<!-- Emulate built in modal header close button action -->
			<b-button size="sm" variant="outline-danger" @click="close()">
				Close Modal
			</b-button>
		</template>

		<!-- BODY -->
		<div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
			<div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
				<h2 >
					<span class="fw-300">ID:{{this.item.uniq_id}}</span>
				</h2>
				<div class="panel-toolbar pr-3 pb-2 align-self-end">
					<button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
						<i class="fal fa-times"></i>
					</button>
				</div>
			</div>

			<div class="panel-container show">

				<b-overlay :show="is_load" rounded="sm">
					<div class="panel-content">
						<div class="d-flex flex-column align-items-center justify-content-center p-4">
							<h5 class="mb-0 fw-700 text-center mt-3">
								{{this.item.title}}
								<small class="text-muted mb-0">
									{{__t('org_info')}}
								</small>
							</h5>
						</div>

						<div>
							<b-tabs content-class="mt-3">
								<b-tab v-for="(tab,index) in tabs" @click="set_active(index)"
									   :disabled="tab.disabled"
									   :title="get_tab_title(tab)"
									   :key="index"
									   :active="tab.is_active"
								>
									<template slot="title">
										{{get_tab_title(tab)}}
										<b-spinner type="grow" small v-if="tab.is_load"></b-spinner>
									</template>

									<component v-bind:is="tab.index" :org="item"></component>

									<div v-if="tab.html !=''">
										{{tab.html}}
									</div>
								</b-tab>
							</b-tabs>
						</div>
						<div>
						</div>
					</div>
				</b-overlay>
			</div>
			<!--FOOTER -->
            <add_org_types></add_org_types>

		</div>

		<template v-slot:modal-footer="{close}">
			<div class="modal-footer">

				<button type="button" @click="remove(false)" class="btn btn-outline-danger waves-effect waves-themed mr-5 pl-5 pr-5" v-if="item_id > 0">
					{{ __t('REMOVE') }}
				</button>

				<button type="button" @click="close()" class="btn btn-secondary waves-effect waves-themed">
					{{ __t('CLOSE') }}
				</button>

				<button type="button" v-on:click="save_rest" class="btn btn-primary waves-effect waves-themed">
					{{ __t('SAVE') }}
				</button>
			</div>
		</template>
	</b-modal>
</template>

<script>

import organization_info from "./tabs/organization_info";
import organization_settings from "./tabs/organization_settings";
import iiko_webhook from "./advanced/iiko_webhook";
import organization_payments from "./tabs/organization_payments";
import organization_shippings from "./tabs/organization_shippings";
import Add_org_types from "./advanced/add_org_types";
import shopify_webhook from "./advanced/shopify_webhook";
import syrve_discount from "./advanced/syrve_discount.vue";
import loyverse_webhook from "./advanced/loyverse_webhook.vue";

export default {
	name: "org_modal",
	components : {
        Add_org_types,
		organization_info,
		organization_settings,
        iiko_webhook,
        organization_payments,
        organization_shippings,
        shopify_webhook,
        syrve_discount,
        loyverse_webhook

	},
	props : {
		modal_position : {
			type : String,
			default : "right"
		},
	},
	data() {
		return {
			item_id : 0,
			item: {
				"id" : 0,
				"title" : "",
				"uniq_id" : ""
			},
			is_load: false,
			is_show_modal: false,
			tabs : []
		}
	},

	created () {
		EventBus.$on("org_edit",res => this.work_click(res));
		EventBus.$on("close_org",this.close);
        EventBus.$on("reload_org",this.load_organization);
	},

	methods : {
		work_click(item_id) {
			this.item_id = item_id;
			this.is_show_modal = true;
			this.load_organization();
		},

		get_tab_title (tab) {
			if(tab.count > 0) {
				return tab.title;
			}
			return tab.title;
		},
		set_active (obj) {
			for (let tab in this.tabs) {
				this.tabs[tab].is_active = false;
			}
			this.tabs[obj].is_active = true;
			EventBus.$emit('update:tabu', {type: this.tabs[obj].index, user_id: this.user_id});
		},

		save_rest () {
			EventBus.$emit("save_org_called");
		},

		close () {
			this.item = {
				id : 0,
				title : "",
				uniq_id : "",
			};

			this.tabs = [];
			this.is_show_modal = false;
		},

		async remove(is_force = false) {
			this.is_load = true;
			let self = this;
			const is_ok = confirm_me(this.__t("ARE_SURE"));
			is_ok.then(res => {
				self.is_load = true;
				api.delete('/internal/v1/catalog/organizations/' + parseInt(self.item.id),{
					'force' : is_force
				}).then(({data}) => {
					self.is_load = false;
					if (data.status === "operation_success") {
						window.location.reload();
					}
				}).catch(({response}) => {
					self.is_load = false;
					EventBus.$emit('show_toast', {
						err: response.data.message, type: "danger",
						title: response.data.status,
						position : "b-toaster-top-left"
					})
				});
			});
		},

		async load_organization () {
			this.is_load = true;
			this.tabs = [];

			await api.post('/internal/v1/catalog/organizations/' + parseInt(this.item_id)).then(({data}) => {
				this.is_load = false;
				if (data.status === "operation_success") {
					this.item = data.data;
                    this.push_tabs();
				}
			}).catch(({response}) => {
				this.is_load = false;
				EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status,position : "b-toaster-top-left"})
			});
		},

        push_tabs() {
            this.default_tabs.map(item => {
                this.tabs.push({
                    title: item.title,
                    disabled: false,
                    is_active: false,
                    is_load: false,
                    index: item.index,
                    html: ''
                });
            });
        },

    },
	computed : {
		dialog_class_draw () {
			if(this.modal_position === "left") {
				return "modal-dialog-left modal-lg";
			}

			return "modal-dialog-right modal-lg";
		},

        default_tabs() {
            let tabs = [
                {
                    "title": this.__t('MAIN_SETTINGS'),
                    "index": "organization_info",
                    is_active:false,
                },
                {
                    "title": this.__t('ADVANCED_SETTINGS'),
                    "index": "organization_settings",
                    is_active:false,
                },
                {
                    "title": this.__t('PAYMENTS'),
                    "index": "organization_payments",
                    is_active:false,
                },
                {
                    "title": this.__t('SHIPPINGS'),
                    "index": "organization_shippings",
                    is_active:false,
                }
            ]


            if(this.item.hasOwnProperty("provider")) {

                let provider = this.item.provider;
                if(provider === 'iikocloud') {
                    tabs.push({
                        "title": this.__t('WEBHOOK'),
                        "index": "iiko_webhook",
                        is_active: false,
                    })

                    tabs.push({
                        "title": this.__t('BONUS_PROGRAM'),
                        "index": "syrve_discount",
                        is_active: false,
                    })
                }

                if(provider === 'shopify') {
                    tabs.push({
                        "title": this.__t('WEBHOOK'),
                        "index": "shopify_webhook",
                        is_active: false,
                    })
                }

                if(provider === 'loyverse_org') {
                    tabs.push({
                        "title": this.__t('WEBHOOK'),
                        "index": "loyverse_webhook",
                        is_active: false,
                    })
                }

            }

            return tabs;
        },
	}
}
</script>

<style scoped>

</style>
